module.exports = __webpack_public_path__ + "static/media/SF-UI-Text-Bold.e9a0cd89.eot";